<template>
    <Fragment>
        <VueScene
                ref="fade_out"
                :keyframes="keyframes_fadeout"
                :autoplay=false
                @ended="onFadedOut">
            <span></span>
        </VueScene>
        <VueScene
                ref="fade_in"
                :keyframes="keyframes_fadein"
                :autoplay=false>
            <span></span>
        </VueScene>
        <div class="apppage visualspage" id="visualspage" :style="showContent? 'display:block':'display: none'">

            <div class="instruction">1. choose a visual layer</div>

            <div class="videooptions">
                <div :class="choice==='bones'? 'videooption selected' : 'videooption'"
                     :style="{'background-image': `url(${require('../assets/video-bones.jpg')})`}"
                     @click="onChoose('bones')">
                    <div class="shroud">
                        bones
                    </div>
                </div>
                <div :class="choice==='flesh'? 'videooption selected' : 'videooption'"
                     :style="{'background-image': `url(${require('../assets/video-flesh.jpg')})`}"
                     @click="onChoose('flesh')">
                    <div class="shroud">
                        flesh
                    </div>
                </div>
                <div :class="choice==='skin'? 'videooption selected' : 'videooption'"
                     :style="{'background-image': `url(${require('../assets/video-skin.jpg')})`}"
                     @click="onChoose('skin')">
                    <div class="shroud">
                        skin
                    </div>
                </div>
            </div>

            <button class="back_btn" @click="$emit('back-clicked')">
                <i class="fal fa-arrow-left"></i>
            </button>

            <button class="wizard_btn" @click="$emit('next-clicked')" :disabled='this.choice.length === 0'>
                next
            </button>

        </div>
    </Fragment>

</template>

<script>

    import { VueScene } from "vue-scenejs";
    import { Fragment } from 'vue-fragment'

    export default {
        name: 'VisualsPage',
        components:{
            VueScene,
            Fragment
        },
        methods:{
            onChoose: function(choice) {
                this.choice = choice;
                this.$emit('choose-video', choice);
            },
            onFadedOut: function() {
                this.showContent = false;
            }
        },
        props: {
            initiallyVisible: Boolean,
            resetCount: Number
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            visible: function(newVal, oldVal) {
                this.showContent = true;

                if(newVal){
                    this.$refs.fade_in.play();
                } else{
                    this.$refs.fade_out.play();
                }
            },
            resetCount: function(newVal, oldVal) {
                if(newVal !== oldVal){
                    this.choice = "";
                }
            }
        },
        data() {
            return {
                choice: "",
                visible: this.initiallyVisible,
                showContent: this.initiallyVisible,
                lastResetCount: 0,
                "keyframes_fadeout": {
                    // eslint-disable-next-line no-unused-vars
                    "#visualspage": i => ({
                        0: {
                            "opacity": 1
                        },
                        0.5: {
                            "opacity": 0
                        },
                        easing: "linear"
                    }),
                },
                "keyframes_fadein": {
                    // eslint-disable-next-line no-unused-vars
                    "#visualspage": i => ({
                        0: {
                            "opacity": 0
                        },
                        0.5: {
                            "opacity": 1
                        },
                        easing: "linear"
                    }),
                }
            };
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import "../assets/styles/variables";

    .visualspage{

        $video-button-height: 214px;

        .instruction {
            position: absolute;
            top:calc((var(--vhc, 100vh) - #{$video-button-height}) / 2 - (#{$video-button-height} * 0.8));
            width: 100%;

            font-family: Lato;
            font-style: normal;
            font-weight: 300;
            font-size: 24px;
            text-align: center;
            letter-spacing: 0.04em;

            color: #FFFFFF;

            @media only screen and (max-height : 580px) {
                top:calc((var(--vhc, 100vh) - 160px) / 2 - (160px));
                font-size: 18px;
            }

        }

        .videooptions {

            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: center;
            align-content: space-between;
            align-items: center;
            position: relative;
            top:calc(var(--vhc, 100vh) / 2 - #{$video-button-height});

            @media only screen and (max-height : 580px) {
                top:calc(var(--vhc, 100vh) / 2 - 170px);
            }

            .videooption {
                width: 380px;
                height: $video-button-height;
                flex: 0 1 auto;
                align-self: auto;
                margin: 10px;
                background-position: center;
                background-size: cover;
                line-height: $video-button-height;
                border: 2px solid #bdbdbd;

                font-family: Cormorant Garamond;
                font-style: normal;
                font-weight: 500;
                font-size: 40px;
                text-align: center;

                cursor: pointer;

                box-shadow: 0 0 0px #fff;
                transition: box-shadow 0.2s;

                @media only screen and (max-height : 580px) {
                    height: 70px;
                    line-height: 70px;
                }


                .shroud {
                    background-color: rgba(0,0,0,0.4);
                    transition: background-color 0.2s;
                }

                &:hover {
                    .shroud {
                        background-color: rgba(0,0,0,0.0);
                        transition: background-color 0.2s;
                    }
                }

                &.selected {
                    box-shadow: 0 0 19px #fff;
                    transition: box-shadow 0.2s;
                    border: 2px solid #ffffff;

                    .shroud {
                        background-color: rgba(0,0,0,0.0);
                        transition: background-color 0.2s;
                    }
                }
            }
        }
    }

</style>
